<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <base-dropdown v-if="activeModules.length > 0">
                <base-button slot="title" type="warning" class="dropdown-toggle">
                    Basic Sales Reports - {{_.startCase(currentProfile)}}
                </base-button>
                <a v-for="profile in activeModules" :key="profile.id"
                    @click.prevent="setCurrentProfile(_.pluralize(_.snakeCase(profile.name)), profile.id)"
                    class="dropdown-item" href="#">{{profile.name}}</a>
            </base-dropdown>
            <base-dropdown v-else>
                <base-button slot="title" type="primary" class="dropdown-toggle">
                    Basic Sales Reports
                </base-button>
                <a class="dropdown-item" disabled>No active module/s under this feature</a>
            </base-dropdown>
        </base-header>
        <!-- <img style="display: none;" id='reportLogo' :src="imagepath" alt='Report Logo' crossorigin="anonymous"/> -->
        <div id="logoDiv" style="display: none;"></div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <item-returns-report v-if="currentProfile == 'item_returns_reports'"></item-returns-report>
                    <item-sales-report v-if="currentProfile == 'item_sales_reports'"></item-sales-report>
                    <matrix-sales-report v-if="currentProfile == 'matrix_sales_reports'"></matrix-sales-report>
                    <category-sales-report v-if="currentProfile == 'category_sales_reports'"></category-sales-report>
                    <category-returns-report v-if="currentProfile == 'category_returns_reports'"></category-returns-report>
                    <stock-valuation-report v-if="currentProfile == 'stock_valuation_reports'"></stock-valuation-report>
                    <stock-valuation-summary v-if="currentProfile == 'stock_valuation_summaries'"></stock-valuation-summary>
                    <general-inventory-report v-if="currentProfile == 'general_inventory_reports'"></general-inventory-report>
                    <item-sales-profit v-if="currentProfile == 'item_sales_profits'"></item-sales-profit>
                    <inventory-aging-report v-if="currentProfile == 'inventory_aging_reports'"></inventory-aging-report>
                    <inventory-aging-valuation v-if="currentProfile == 'inventory_aging_valuations'"></inventory-aging-valuation>
                    <stock-activity-valuation v-if="currentProfile == 'stock_activity_valuations'"></stock-activity-valuation>
                    <oms-collection-report v-if="currentProfile == 'oms_collection_reports'"></oms-collection-report>
                    <oms-daily-sales-report v-if="currentProfile == 'oms_daily_sales_reports'"></oms-daily-sales-report>
                    <hourly-sales-report v-if="currentProfile == 'hourly_sales_reports'"></hourly-sales-report>
                    <wallet-payment-report v-if="currentProfile == 'pos_e_wallet_payment_reports'"></wallet-payment-report>
                    <day-part-sales-report v-if="currentProfile == 'day_part_sales_reports'"></day-part-sales-report>
                    <tender-totals-report v-if="currentProfile == 'tender_totals_reports'"></tender-totals-report>
                    <tender-summary-report v-if="currentProfile == 'tender_summary_reports'"></tender-summary-report>
                    <void-cancel-refund-report v-if="currentProfile == 'void_cancel_refund_reports'"></void-cancel-refund-report>
                    <hourly-sales-by-segment-report v-if="currentProfile == 'hourly_sales_by_segment_reports'"></hourly-sales-by-segment-report>
                    <reservation-report v-if="currentProfile == 'reservation_reports'"></reservation-report>
                    <product-sales-per-segment-report v-if="currentProfile == 'product_sales_per_segment_reports'"></product-sales-per-segment-report>
                    <sales-per-segment-report v-if="currentProfile == 'sales_per_segment_reports'"></sales-per-segment-report>
                    <daily-sales-report v-if="currentProfile == 'daily_sales_reports'"></daily-sales-report>
                    <hourly-order-creation-report v-if="currentProfile == 'hourly_order_creation_reports'"></hourly-order-creation-report>
                    <dine-and-delight-report v-if="currentProfile == 'dine_and_delight_reports'"></dine-and-delight-report>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import ItemReturnsReport from '../Basic Sales Reports/ItemReturnsReport';
    import ItemSalesReport from '../Basic Sales Reports/ItemSalesReport';
    import MatrixSalesReport from '../Basic Sales Reports/MatrixSalesReport';
    import CategorySalesReport from '../Basic Sales Reports/CategorySalesReport';
    import CategoryReturnsReport from '../Basic Sales Reports/CategoryReturnsReport';
    import StockValuationReport from '../Basic Sales Reports/StockValuationReport';
    import StockValuationSummary from '../Basic Sales Reports/StockValuationSummary';
    import GeneralInventoryReport from '../Basic Sales Reports/GeneralInventoryReport';
    import ItemSalesProfit from '../Basic Sales Reports/ItemSalesProfit';
    import InventoryAgingReport from '../Basic Sales Reports/InventoryAgingReport';
    import InventoryAgingValuation from '../Basic Sales Reports/InventoryAgingValuation';
    import StockActivityValuation from '../Basic Sales Reports/StockActivityValuation';
    import OmsCollectionReport from '../Basic Sales Reports/OmsCollectionReport';
    import OmsDailySalesReport from '../Basic Sales Reports/OmsDailySalesReport';
    import HourlySalesReport from '../Bir Reports/HourlySalesReport';
    import HourlyOrderCreationReport from '../Basic Sales Reports/HourlyOrderCreationReport';
    import WalletPaymentReport from '../Basic Sales Reports/WalletPaymentReport';
    import DayPartSalesReport from '../Basic Sales Reports/DayPartSalesReport';
    import TenderTotalsReport from '../Basic Sales Reports/TenderTotalsReport';
    import TenderSummaryReport from '../Basic Sales Reports/TenderSummaryReport';
    import VoidCancelRefundReport from '../Basic Sales Reports/VoidCancelRefundReport';
    import HourlySalesBySegmentReport from '../Basic Sales Reports/HourlySalesBySegmentReport';
    import ReservationReport from './ReservationReport.vue';
    import ProductSalesPerSegmentReport from './ProductSalesPerSegmentReport.vue';
    import SalesPerSegmentReport from './SalesPerSegmentReport.vue';
    import DailySalesReport from '../Basic Sales Reports/DailySalesReport.vue';
    import DineAndDelightReport from '../Basic Sales Reports/DineAndDelightReport.vue';
    import {
        mapState,
        mapActions
    } from 'vuex'

    export default {
        data() {
            return {
                activeModules: [],
                accessRights: [],
                imagepath: secureStorage.getItem("account_logo")
            }
        },
        mounted: async function () {
            var component_x = this;
            
            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            corsImageModified.crossOrigin = "Anonymous";
            corsImageModified.id = "reportLogo";
            corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            document.getElementById("logoDiv").appendChild(corsImageModified);
            //Fix: S3 image CORS error in jsPDF

            var categoryId = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories?code=R-001&status=A', null, null)
            if(categoryId[0] != undefined){
                component_x.activeModules = await HTTPRequest.getRequest(component_x.endPoint + '/system_module_categories/' + categoryId[0].id + '/enabled_modules', null, null)
                if (component_x.activeModules.length > 0) {
                    var profile = _.snakeCase(component_x.activeModules[0].name)
                    component_x.setCurrentProfile(_.pluralize(profile), component_x.activeModules[0].id);
                } else {
                    component_x.setCurrentProfile(null, null);
                }
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components: {
            ItemReturnsReport,
            ItemSalesReport,
            MatrixSalesReport,
            CategorySalesReport,
            CategoryReturnsReport,
            StockValuationReport,
            StockValuationSummary,
            GeneralInventoryReport,
            ItemSalesProfit,
            InventoryAgingReport,
            InventoryAgingValuation,
            StockActivityValuation,
            OmsCollectionReport,
            OmsDailySalesReport,
            HourlySalesReport,
            WalletPaymentReport,
            DayPartSalesReport,
            TenderTotalsReport,
            TenderSummaryReport,
            VoidCancelRefundReport,
            HourlySalesBySegmentReport,
            ReservationReport,
            ProductSalesPerSegmentReport,
            SalesPerSegmentReport,
            DailySalesReport,
            HourlyOrderCreationReport,
            DineAndDelightReport
            
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            async setCurrentProfile(profile, id) {
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + id, null)
                if (_.isEmpty(accessRightsRequest.access_rights) == false){
                    this.accessRights = accessRightsRequest.access_rights[id]
                }else {
                    this.accessRights = []
                }
                this.updateCurrentProfile(profile);
            }
        }
    };
</script>

<style></style>